import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertController, ModalController, Platform } from '@ionic/angular';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { environment } from '../environments/environment';
import { AnalyticsService } from '../smoothr-web-app-core/services/analytics/analytics.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Api } from '../smoothr-web-app-core/api/api';

// import { SwUpdate } from '@angular/service-worker';
import { NavigationService } from './services/navigation.service';
import { filter } from 'rxjs/operators';

import { register } from 'swiper/element/bundle';
import { CookieConsentService } from './services/cookie.service';
import { TracifyService } from './services/tracify.service';
import { RepositoryService } from '../smoothr-web-app-core/services/repository/repository.service';
import { PaymentStatus } from '../smoothr-web-app-core/models/PaymentStatus';
import Payment from '../smoothr-web-app-core/models/Payment';
import Order from '../smoothr-web-app-core/models/Order';
import { InfoModalComponent } from './components/info-modal/info-modal.component';
import { PaymentModalResult } from './components/payment-modal/payment-modal.component';
import {PaymentCancelledModalComponent} from './components/payment-cancelled-modal/payment-cancelled-modal.component';
import { HelloAgainService } from './services/hello-again.service';
register();

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
	static largeScreen = false;
	static analyticsEnabled = false;
	isCookieAccepted = false;
	static hideLogo = false;
	constructor(
		private route: ActivatedRoute,
		private alertCtrl: AlertController,
		private snackbarCtrl: MatSnackBar,
		private router: Router,
		private analytics: AnalyticsService,
		platform: Platform,
		private translate: TranslateService,
		private cookieService: CookieConsentService,
		private repository: RepositoryService,
		private navigationService: NavigationService,
		private modalCtrl: ModalController,
		private tracifyService: TracifyService,
		private helloAgainService: HelloAgainService
	) {
		console.log(environment.customerGroup + ' ' + environment.version);
		const favIcon: any = document.querySelector("link[rel*='icon']") || document.createElement('link');
		favIcon.type = 'image/x-icon';
		favIcon.rel = 'shortcut icon';
		favIcon.href = '/assets/losteria/logo.svg';
		document.getElementsByTagName('head')[0].appendChild(favIcon);
		// Check for saved language preference, default to 'de' if not found
		const savedLanguage = localStorage.getItem('selectedLanguage') || 'de';
		translate.setDefaultLang(savedLanguage);
		translate.use(savedLanguage).subscribe(() => {
			// Set title after translations are loaded
			translate.get('index.title.' + environment.customerGroup).subscribe((translatedTitle: string) => {
				document.title = translatedTitle;
			});
		});
		this.handleCookieConsent();
		platform.ready().then(() => {
			AppComponent.largeScreen = platform.width() >= 992;
			platform.resize.subscribe(() => {
				AppComponent.largeScreen = platform.width() >= 992;
			});

			// Tracify initialization is now handled by CookieConsentService after marketing consent

			// Initialize React Native webview auto-login
			if (window.ReactNativeWebView) {
				this.helloAgainService.autoLoginWithWebViewToken().then(success => {
					if (success) {
						console.log('React Native auto-login successful');
					} else {
						console.log('React Native auto-login failed or not available');
					}
				});
			}
		});
		Api.isMaintenanceActive()
			.then(result => {
				if (result) {
					this.navigationService.maintenance();
				}
			})
			.catch(error => {
				console.log(error);
			});
		this.route.queryParams.pipe().subscribe(params => {
			if (params?.logo) {
				AppComponent.hideLogo = params.logo;
			}
		});
	}
	async ngOnInit() {
		this.checkPayments();
	}

	async setAnalyticsEnabled(enabled: boolean) {
		await this.analytics.setAnalyticsCollectionEnabled(enabled);
	}

	private async initCookieConsent() {}
	openPage(value: string) {
		if (!value) {
			return;
		}
		this.router.navigate([value]);
	}
	private handleCookieConsent() {
		try {
			this.cookieService.initializeCookieConsent();
		} catch (e) {}
	}

	checkPayments() {
		this.repository.checkOpenPayment().then(async result => {
			if (!result) {
				console.log('No Payment open.', result);
				return;
			}
			console.log(result);
			console.log({
				paymentDone: result.payment?.status === PaymentStatus.done,
				orderIsPaid: result.order?.isPayed,
			});
			if (result.payment?.status === PaymentStatus.done || result.order?.isPayed) {
				console.log('Navigate to payment success.');
				await this.router.navigate(['/payment/success/', result.payment?._id ?? result.order?.paymentId], {
					queryParams: { order: result.payment?.orders[0] ?? result.order?._id },
				});
				return;
			}
			this.showErrorPayment(result.payment, result.order);
		});
	}

	async showErrorPayment(payment: Payment, order: Order) {
		const retryResponse = await PaymentCancelledModalComponent.show(this.modalCtrl);
		if (!retryResponse) {
			await InfoModalComponent.show(this.modalCtrl, {
				title: this.translate.instant('error_dialog.title'),
				info: this.translate.instant('error_dialog.info'),
				closeButton: this.translate.instant('error_dialog.closeButton'),
			});
			this.repository.payment.next(null);
			return;
		}
		const result = await this.repository.showPaymentModal(
			this.modalCtrl,
			this.repository._venue,
			order,
			this.repository._customerAuth.customer,
			payment.tip,
			false
		);
		if (result?.result === PaymentModalResult.SUCCESS) {
			this.repository.verifiedOrder.emit(order);
			this.repository.payment.emit(result.payment);
			await this.navigationService.paymentSuccess(order._id, result.payment._id);
			return;
		}
	}
}
